import { useCallback, useEffect, useState } from 'react';
import { storageConfigurationApiArea } from '@/services/api/storageConfigurationApiArea';
import { IStorageConfiguration } from '@/services/api/storageConfigurationApiArea/types';

export interface StorageReturnParams {
  storages: IStorageConfiguration[];
  isLoading: boolean;

  fetchStorages: () => Promise<void>;
}

const useStoragePage = (): StorageReturnParams => {
  const [storages, setStorages] = useState<IStorageConfiguration[]>([]);
  const [isLoading, setLoading] = useState(true);

  const fetchStorages = useCallback(async () => {
    try {
      setLoading(true);
      const data = await storageConfigurationApiArea().GetStorageConfigurations();
      setStorages(data);
    } catch (error) {
      // Игнорируем ошибку
    } finally {
      setLoading(false);
    }
  }, []);

  useEffect(() => {
    fetchStorages();
  }, [fetchStorages]);

  return {
    storages,
    isLoading,
    fetchStorages
  };
};

export default useStoragePage;
